var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{staticClass:"secondary--text ml-0 ml-sm-3 mr-1 barcode-btn no-border",attrs:{"loading":_vm.loading,"icon":"","aria-label":"Scansiona prodotti per codice a barre"},on:{"click":function($event){return _vm.scan()}}},[_c('v-icon',[_vm._v(" $qrCode ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }